<template>
  <div class="container-fluid">
    <notifications></notifications>
    <navmenu :menuMobile="true"></navmenu>

    <div class="row pt-lg-0 pt-md-0 pt-sm-0 pt-2  mob-log">
      <div
        class="col-xl-5 col-lg-5 col-md-5 col-sm-5  d-flex justify-content-center align-items-center min-vh-lg-100 align-self-center box-log"
      >
        <div
          class="col-xl-8 col-lg-10 col-md-11 col-sm-12 col-12 pt-lg-0 pt-md-5 pt-sm-5 pt-0"
        >
          <div class="text-center mb-4">
            <h1 class="title-view-2">Sign In</h1>
            <div class="textInHorizontalLine">
              <span>Suppliers</span>
            </div>
          </div>

          <div class="mb-0 mt-4">
            <form role="form" @submit.prevent>
              <div class="row">
                <div class="col-12 mb-3 mt-2">
                  <base-input
                    id="email"
                    name="email"
                    placeholder="Email"
                    v-model="data.email"
                    label="Email"
                    type="email"
                    markrequired
                    :error="
                      !$v.data.email.email || $v.data.email.$error
                        ? `Enter Email`
                        : ''
                    "
                    :focusact="true"
                  ></base-input>
                </div>

                <div class="col-12">
                  <base-input
                    v-model="$v.data.password.$model"
                    :label="$t('labelsForms.user.password')"
                    placeholder="Password"
                    name="password"
                    id="password"
                    :type="typePassword"
                    autocomplete="new-password"
                    maxlength="20"
                    class="input-append"
                    markrequired
                    :error="
                      !$v.data.password.minLength || $v.data.password.$error
                        ? `Enter a valid password`
                        : ''
                    "
                    v-bind:class="{
                      'is-invalid': $v.data.password.$error
                    }"
                    ><template slot="append">
                      <span @click="seePassword()" class="icon-button"
                        ><i
                          v-bind:class="{
                            'flaticon-view-1': typePassword == 'password',
                            'flaticon-hidden': typePassword == 'text'
                          }"
                        ></i
                      ></span>
                    </template>
                  </base-input>
                </div>

                <div class="col-12">
                  <base-checkbox
                    id="remember"
                    name="remember"
                    class="text-dark mb-3"
                    v-model="remember"
                    >Remember me</base-checkbox
                  >

                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="min-button icon-move"
                      @click="login"
                      nativeType="submit"
                      >Sign in
                      <i class="ml-2 mr-0 flaticon-right-1 arrow-icon"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </form>

            <div class="mt-2 text-center mb-3">
              <router-link to="/forgot-password" class="d-block f-14"
                >Forgot your password?</router-link
              >
            </div>

            <div class="loading mt-5" v-if="load">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>

            <base-alert
              :type="alert.type"
              dismissible
              v-if="alert.status"
              class="alert-base"
            >
              <span class="alert-inner--icon">
                <i :class="alert.icon" class="mr-2"></i>
              </span>
              <span class="alert-inner--text">
                <strong>{{ alert.title }}</strong>
                {{ alert.message }}
              </span>
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </base-alert>
          </div>
        </div>
      </div>

      <div
        class="col-xl-7 col-lg-7 col-md-7 col-sm-7 d-flex justify-content-center align-items-center min-vh-lg-100 flex-column img-back-pages align-self-center"
        v-bind:style="{
          'background-image':
            'url(https://upcdn.io/FW25b8h/raw/public/coverApps/' + src + ')'
        }"
      >
        <div class="overimg-back"></div>
        <div
          class="col-xl-9 col-lg-10 col-md-11 col-sm-12 col-12 pt-lg-0 pt-md-3 pt-sm-0 pt-0 no-movil"
        >
          <div class="card card-trans mb-0">
            <div class="content-description ">
              <h2>Welcome to RhomTrip!!</h2>
              <p class="description">
                The all-in-one tool, RhomTrip Mobility, is a cloud-based
                solution that caters to the needs of small and medium-sized
                suppliers, as well as a wide range of travel partners including
                Agents, Agencies, and suppliers.
              </p>
            </div>

            <footer class="footer-pages-ext">
              <div class="container content border-top-1 pt-2">
                <div class="row justify-content-center ">
                  <div
                    class="col-xl-8 col-lg-12 col-md-12 col-sm-12 content-footer align-self-center "
                  >
                    <img
                      src="~rhomtrip_assets/src/img/brand/rhomtrip-v1p300.png"
                      class="logo"
                      alt="Logo Rhomtrip"
                    />
                    <span>Seamless Travel Experiences</span>
                    <ul class="social-media">
                      <li>
                        <a
                          href="https://www.linkedin.com/company/rhomtrip"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-linkedin"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/rhomtrip/"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/rhomtrip"
                          target="blank"
                        >
                          <i
                            class="flaticon-bold flaticon-bold-facebook-app-symbol"
                          ></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.x.com/rhomtrip"
                          target="_blank"
                          aria-label="twitter RhomTrip"
                        >
                          <i class="flaticon-web-twitter-1"></i>
                        </a>
                      </li>

                      <li>
                        <a href="mailto:info@rhomtrip.com" target="_blank">
                          <i class="flaticon-envelope"></i>
                        </a>
                      </li>

                      <li>
                        <a href="https://rhomtrip.com/contact" target="blank">
                          <i class="flaticon-bold-telephone"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="bottom-footer-log">
                <div class="container cont-footer border-top-1 pt-1">
                  <div class="row justify-content-center">
                    <div class="col-xl-11 col-lg-11 col-md-11 col-sm-12 col-11">
                      <div class="row justify-content-center">
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 align-self-center"
                        >
                          <a href="https://www.iata.org" target="_blank">
                            <img
                              class="img-fluid"
                              src="~rhomtrip_assets/src/img/partnership/iata-rhomtrip.png"
                              alt="iata"
                          /></a>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 align-self-center"
                        >
                          <a href="https://www.asta.org/" target="_blank">
                            <img
                              class="img-fluid"
                              src="~rhomtrip_assets/src/img/partnership/asta-travel-advisors.png"
                              alt="asta"
                          /></a>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 align-self-center"
                        >
                          <a href="https://www.octo.travel" target="_blank">
                            <img
                              class="img-fluid"
                              src="~rhomtrip_assets/src/img/partnership/octo-travel.png"
                              alt="octo"
                          /></a>
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 align-self-center"
                        >
                          <a href="https://www.tripadvisor.com" target="_blank">
                            <img
                              class="img-fluid"
                              src="~rhomtrip_assets/src/img/partnership/tripadvisor-2023.png"
                              alt="tripadvisor"
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-12 text-center align-self-center border-top-1 pt-2"
                  >
                    <p>
                      Copyright © {{ systemInfo.year }}. RhomTrip OÜ™. Register
                      Nº: 14554819. All Rights Reserved.
                    </p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
      <layoutFooter class="footer-pages no-desktop"></layoutFooter>
    </div>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../Commons/Services/index";
import { mapMutations, mapGetters } from "vuex";
import layoutFooter from "../Layout/ContentFooter";
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        email: "",
        password: ""
      },
      message: "",
      remember: false,
      load: false,
      alert: {
        type: "",
        title: "",
        message: "",
        icon: "",
        class: "",
        status: false
      },
      typePassword: "password",
      src: "backRhomTrip2.jpg",
      photos: [
        { id: 1, title: "RhomTrip", name: "backRhomTrip1.jpg" },
        { id: 2, title: "RhomTrip", name: "backRhomTrip2.jpg" },
        { id: 3, title: "RhomTrip", name: "backRhomTrip3.jpg" },
        { id: 4, title: "RhomTrip", name: "backRhomTrip4.jpg" },
        { id: 5, title: "RhomTrip", name: "backRhomTrip5.jpg" }
      ]
    };
  },
  created() {
    this.setSesion(null);
    this.setSigOut(false);
    localStorage.removeItem("es-login");
    localStorage.removeItem("settings");
    let remember = localStorage.checkbox && localStorage.checkbox;

    if (this.$route.query.email) {
      this.data.email = this.$route.query.email;
    } else {
      this.data.email = remember ? localStorage.user_email : "";
      this.data.password = remember ? localStorage.pass : "";
    }
    this.setTempPagination({
      currentPage: 1,
      query: "",
      queryTemp: "",
      filteredTabStatus: "all",
      limit: "15",
      status: false
    });
    this.src = this.photos[this.random()].name;
  },
  methods: {
    async login() {
      try {
        if (!this.$v.$invalid) {
          this.rememberMe();
          this.load = true;
          let { data } = await endpoint.auth.services.login({
            email: this.data.email.toLowerCase(),
            password: this.data.password
          });
          this.load = false;
          if (data.status) {
            let sesion = data.data;
            if (sesion.role === "supplier") {
              sesion["status"] = true;
              localStorage.setItem("es-login", JSON.stringify(sesion));
              this.setSettings(sesion.settings);
              this.setSesion(sesion);
              this.$router.push("/reservations");
            } else {
              this.loginError();
            }
          } else {
            this.loginError();
          }
        } else {
          this.$v.data.$touch();
        }
      } catch (error) {
        this.load = false;
        if (error.response.status === 404) {
          let data = error.response.data.data;
          if (data.profile === "inactive") {
            this.loginWarning();
          } else {
            this.loginError();
          }
        } else {
          this.loginError();
        }
      }
    },
    loginError() {
      this.alert = {
        type: "danger",
        title: "Error!",
        message: "Incorrect Email or Password Entered",
        icon: "flaticon-remove",
        class: "alert-danger",
        status: true
      };
    },
    loginWarning() {
      this.alert = {
        type: "warning",
        title: "Important!",
        message: "This user is currently inactive",
        icon: "flaticon-warning-1",
        class: "alert-warning",
        status: true
      };
    },
    rememberMe() {
      if (this.remember && this.data.email !== "") {
        localStorage.user_email = this.data.email;
        localStorage.pass = this.data.password;
        localStorage.checkbox = this.remember;
      } else {
        localStorage.user_email = "";
        localStorage.checkbox = "";
        localStorage.pass = "";
      }
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    random: function() {
      return Math.floor(Math.random() * this.photos.length);
    },
    ...mapMutations([
      "setSesion",
      "setSigOut",
      "setLoad",
      "setSettings",
      "setTempPagination",
      "setSystemInfo",
      "setModuleSettings"
    ])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  },
  validations: {
    data: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
